import { Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
} from '@angular/material/dialog';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { MatButtonModule } from '@angular/material/button';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-logs-preview-dialog',
  imports: [MatDialogContent, MatDialogActions, MatButtonModule, TitleCasePipe],
  templateUrl: './logs-preview-dialog.component.html',
  styleUrl: './logs-preview-dialog.component.scss',
})
export class LogsPreviewDialogComponent {
  readonly dialogRef = inject(MatDialogRef<LogsPreviewDialogComponent>);

  readonly data = inject<DialogData & { logs: string[]; type: string }>(MAT_DIALOG_DATA);

  download(): void {
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
